
































































































import { Component, Vue } from 'vue-property-decorator';

import { reverse } from 'lodash';
import TransactionParticipantModal from '@/components/TransactionParticipantModal.vue';

import BankAccountsModule from '@/store/bank-accounts';
import { BankAccount } from '@/api/payment-orders';
import PartyModal from '@/components/PartyModal.vue';

@Component({
  components: { PartyModal, TransactionParticipantModal },
})
export default class PartiesPage extends Vue {
  party: Partial<BankAccount> | null = null;

  isPartyModalOpen = false;

  get parties() {
    if (!BankAccountsModule.bankAccounts) {
      return [];
    }
    return reverse([...BankAccountsModule.bankAccounts]);
  }

  onCreate() {
    this.openPartyModal();
  }

  handleEdit(i: number, party: BankAccount) {
    this.openPartyModal(party);
  }

  async handleDelete(i: number, party: BankAccount) {
    try {
      await this.$confirm(`Jeste li sigurni da želite obrisati stranku: "${party.name}"?`, 'Potvrda', {
        confirmButtonText: 'Da',
        confirmButtonClass: 'bg-red-500',
        cancelButtonText: 'Ne',
        type: 'warning',
      });

      await this.deleteParty(party);
    } catch (e) {
    // user declined
    }
  }

  async deleteParty(party: BankAccount) {
    try {
      await BankAccountsModule.deleteBankAccount(party.id);
    } catch (e) {
      console.error({ e });
    }
  }

  openPartyModal(party: Partial<BankAccount> | null = null) {
    this.party = party;

    this.isPartyModalOpen = true;
  }
}
